import axios from 'axios'

interface GetClientIpResponse {
  ip: string
}

export default function useClientApi() {
  const getClientIp = async (): Promise<string> => {
    const defaultIp = '0.0.0.0'
    try {
      const res = await axios.get<GetClientIpResponse>('https://api.ipify.org/?format=json')
      return res.data.ip || defaultIp
    } catch (error) {
      return defaultIp
    }
  }

  return { getClientIp }
}
